import { render } from "./App.vue?vue&type=template&id=4b336e7a"
const script = {}

import exportComponent from "/Users/dmitrii.verov/website/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__